import React from 'react';
import ReactVisibilitySensor from 'react-visibility-sensor';

export interface VisibilityWrapperInterface {
  setVisibility: (isVisible: boolean) => void;
}

const VisibilityWrapper: React.FC<VisibilityWrapperInterface> = ({setVisibility, children}) => {

  const onVisibilityChange = (isVisible: boolean) => setVisibility(isVisible);

  return <ReactVisibilitySensor onChange={onVisibilityChange}>
    {children}
  </ReactVisibilitySensor>;
};

export default VisibilityWrapper;
